<div>
  <br>
  <br>
  <br>
  <button type="button" (click)="loginWithGoogle()" class="btn btn-danger">Login with Google</button>
</div>
